var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useModal } from "../Modal";
import { LinkButton } from "../controls/LinkButton";
import { createUIElement } from "../helpers";
export var SelectLink = createUIElement('SelectLink', function (_a, ref) {
    var _b;
    var className = _a.className, renderModal = _a.renderModal, id = _a.id, disabled = _a.disabled, error = _a.error, contentIconBefore = _a.contentIconBefore, contentIconAfter = _a.contentIconAfter, renderContent = _a.renderContent, 
    /**
     * Property emptyText is deprecated. You should use only renderContent
     * @deprecated
     */
    emptyText = _a.emptyText, 
    /**
     * Property textRenderer is deprecated. You should use only renderContent
     * @deprecated
     */
    textRenderer = _a.textRenderer, compact = _a.compact, onFocus = _a.onFocus, onBlur = _a.onBlur, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "renderModal", "id", "disabled", "error", "contentIconBefore", "contentIconAfter", "renderContent", "emptyText", "textRenderer", "compact", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var _c = useModal((_b = {
            render: renderModal
        },
        _b['data-selector-id'] = 'select-link-modal-overlay',
        _b)), modal = _c[0], modalActions = _c[1];
    if (typeof emptyText === 'string') {
        console.warn('@Deprecated: emptyText has been removed and is not recommended for use. Use "renderContent" property');
        if (!textRenderer && !renderContent) {
            renderContent = function () { return emptyText; };
        }
    }
    if (typeof textRenderer === 'function') {
        console.warn('@Deprecated: textRenderer has been renamed and changed injected props, is not recommended for use. Use "renderContent" property');
        if (!renderContent) {
            renderContent = function () { return textRenderer(emptyText); };
        }
    }
    if (!textRenderer && !renderContent) {
        console.warn('SelectLink Error: renderContent must be set');
    }
    var handleClick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!disabled && !modalActions.isActive) {
            modalActions.activate();
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(LinkButton, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || id || 'select-link', className: "vm-SelectLink " + className, disabled: disabled, error: error, iconBefore: contentIconBefore, compact: compact, iconAfter: contentIconAfter, onFocus: onFocus, onBlur: onBlur, onClick: handleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), renderContent === null || renderContent === void 0 ? void 0 : renderContent({ error: error, disabled: disabled })),
        modal));
});
//# sourceMappingURL=SelectLink.js.map